import React, { useContext } from "react";
import { useMsal } from "@azure/msal-react";
import { RxHamburgerMenu } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import { RiAdminLine } from "react-icons/ri";
import { IoIosLogOut } from "react-icons/io";
import appContext from "../../../context/app/appContext";

const NavBar = (props) => {
  const { instance } = useMsal();
  const { toggleSidebar, isSidebarOpen } = props;
  const app_context = useContext(appContext);
  const { authLevel } = app_context;
  const navigate = useNavigate();

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  return (
    <div
      style={{ height: "50px", minHeight: "50px", flexShrink: 0 }}
      className="flex items-center justify-between  px-4  bg-blue-600 shadow-md"
    >
      <div className="flex items-center gap-4">
        {!isSidebarOpen && (
          <RxHamburgerMenu
            onClick={toggleSidebar}
            className="text-white hover:text-blue-200 hover:scale-110 cursor-pointer transition"
            size={28}
          />
        )}

        {!isSidebarOpen && (
          <div
            onClick={() => navigate("/")}
            className="flex items-center gap-2 hover:cursor-pointer group"
          >
            <img
              src="/GoNoTicks.png"
              alt="Go"
              style={{ height: "50px" }}
              className="duration-300  hover:cursor-pointer hover:scale-105 "
            />
            {/* <span className="text-gray-100 hover:text-amber-500 text-xl font-semibold group-hover:text-orange-300 transition hover:scale-105">
              Go Redeemer
            </span> */}
          </div>
        )}
      </div>

      <div className="flex items-center gap-4">
        {authLevel === "admin" && (
          <RiAdminLine
            onClick={() => navigate("/admin")}
            className="text-white hover:text-yellow-400 hover:scale-110 cursor-pointer transition"
            size={26}
          />
        )}
        <IoIosLogOut
          onClick={handleLogout}
          className="text-white hover:text-yellow-400 hover:scale-110 cursor-pointer transition"
          size={28}
        />
      </div>
    </div>
  );
};

export default NavBar;
